import { createSlice } from '@reduxjs/toolkit';

export const invitationSlice = createSlice({
    name: 'invitation',
    initialState: {
        data: null,
    },
    reducers: {
        setInvitation: (state, { payload }) => {
            state.data = payload;
        },
    },
});

export const { setInvitation } = invitationSlice.actions;

export default invitationSlice.reducer;
